function getColorBrightness(rgbColor) {
  var colorValues = rgbColor.match(/[\d\.]+/g).map(Number);
  return 0.2126 * (colorValues[0] / 255) + 0.7152 * (colorValues[1] / 255) + 0.0722 * (colorValues[2] / 255);
}

function isSimilarToBackground(color) {
  var backgroundColor = 'rgb(255, 255, 255)';

  var colorBrightness = getColorBrightness(color);
  var backgroundColorBrightness = getColorBrightness(backgroundColor);

  return (backgroundColorBrightness / colorBrightness) < 1.5;
}

var SwatchColors = (function() {
  function SwatchColors() {
    this.colors = {'black': 'rgb(2, 2, 3)','olive': 'rgb(93, 89, 55)','shadow': 'rgb(161, 160, 156)','champagne': 'rgb(233, 219, 205)','camel': 'rgb(209, 132, 25)','camel-matte': 'rgb(224, 165, 90)','mustard': 'rgb(232, 215, 153)','crystal-brown': 'rgb(239, 180, 144)','nude': 'rgb(243, 219, 191)','brown': 'rgb(172, 105, 69)','rosie': 'rgb(223, 201, 187)','blue-stone': 'rgb(103, 121, 140)','midnight-olive': 'rgb(106, 110, 95)',};

    this.images = {'dark-tortoise': 'url("//broolls.com/cdn/shop/files/dark-tortoise_120x.jpg?v=13741271889443991946")','tortoise': 'url("//broolls.com/cdn/shop/files/tortoise_120x.jpg?v=17783062476655143429")','marble': 'url("//broolls.com/cdn/shop/files/marble_120x.jpg?v=261791419149747843")','tortoise-matte': 'url("//broolls.com/cdn/shop/files/tortoise-mate_120x.jpg?v=3941840639933988515")','pearl': 'url("//broolls.com/cdn/shop/files/pearl_120x.jpg?v=4986586867295699981")','gold-tortoise': 'url("//broolls.com/cdn/shop/files/gold-tortoise_120x.jpg?v=7027956710147169474")','honey-tortoise': 'url("//broolls.com/cdn/shop/files/honey-tortoise_120x.jpg?v=16709773269168567875")','olive-tortoise': 'url("//broolls.com/cdn/shop/files/olive-tortoise_120x.jpg?v=5006194224801544102")','yellow-tortoise': 'url("//broolls.com/cdn/shop/files/dark-tortoise_120x.jpg?v=13741271889443991946")',};

    this.triggers = ['color','colour','couleur','farbe','cor',];
  }

  function setSwatchColor(swatch) {
    var swatchId = swatch.getAttribute('swatch-id');

    if (Object.keys(this.colors).includes(swatchId)) {
      swatch.style.setProperty("--background-graphic", this.colors[swatchId]);

      if (isSimilarToBackground(this.colors[swatchId])) swatch.classList.add('is-similar-to-background');
      if (getColorBrightness(this.colors[swatchId]) > 0.5) {
        swatch.style.setProperty('--tick-color', '#000');
      } else {
        swatch.style.setProperty('--tick-color', '#fff');
      }
      swatch.classList.remove('is-blank');
    }

    if (Object.keys(this.images).includes(swatchId)) {
      swatch.style.setProperty("--background-graphic", this.images[swatchId]);
      swatch.classList.add('is-image');
      swatch.classList.remove('is-blank');
    }
  }
  SwatchColors.prototype.setSwatchColor = setSwatchColor;

  return SwatchColors;
}());

const Swatches = new SwatchColors();

function VariantSwatch() {
  return Reflect.construct(HTMLElement, [], this.constructor);
}

VariantSwatch.prototype = Object.create(HTMLElement.prototype);
VariantSwatch.prototype.constructor = VariantSwatch;
Object.setPrototypeOf(VariantSwatch, HTMLElement);

VariantSwatch.prototype.connectedCallback = function() {
  Swatches.setSwatchColor(this);
};
customElements.define('variant-swatch', VariantSwatch);

export default Swatches;
